import { useState, useEffect, useCallback } from "react";
import useAxios from "../api/useAxios";

export const useGetDetail = (endpoint, id) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const apiInstance = useAxios();

  const fetchData = useCallback(
    async (customId = null) => {
      const targetId = customId || id;
      if (!targetId) {
        setError("ID is required for fetching detail data");
        return;
      }

      setLoading(true);
      setError(null);

      try {
        const response = await apiInstance.get(`${endpoint}/${targetId}`);
        console.log(response);
        const resultData = response.data.data || response.data;
        setData(resultData);
        return resultData;
      } catch (err) {
        const errorMessage =
          err.response?.data?.message ||
          err.message ||
          "An error occurred while fetching detail data";
        setError(errorMessage);
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [endpoint, id],
  );

  // const refetch = useCallback(
  //   (customId = null) => {
  //     return fetchData(customId);
  //   },
  //   [fetchData],
  // );

  useEffect(() => {
    if (id) {
      fetchData();
    }
  }, [id, fetchData]);

  return {
    data,
    loading,
    error,

    fetchData,
  };
};
